import styled from "@emotion/styled";

export const Styles = styled.div`
  .mode-edit {
    .ant-table-tbody {
      .ant-table-cell {
        padding: 10px 16px;
      }
    }
  }

   .ant-table-cell {
        padding: 0 16px !important;
      }
  .ant-form-item {
    margin: 0;
  }
  .ant-table-thead {
    .ant-table-cell {
      background: #ecebeb;
    }
  }
  tr:nth-child(even) {
    .ant-table-cell {
      background: #ecebeb;
    }
  }
`;
